import { fork, call, put, select } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'

import * as fromEntities from '@src/redux/modules/entities'
import * as fromAliada from '@src/redux/modules/aliada'
import { aliadas } from '@src/services/api'

// /////////////////////////////////////////////////////////////////////////////
// Sagas
// /////////////////////////////////////////////////////////////////////////////
export function* fetch (action) {
  const { aliadaId, filters } = action.payload

  yield put({ type: fromAliada.FETCH_STARTED })

  const { response, error } = yield call(aliadas.fetch, aliadaId, filters)
  if (error) {
    return yield put({
      type: fromAliada.FETCH_FAILURE,
      payload: error,
      error: true
    })
  }

  yield put({
    type: fromAliada.FETCH_SUCCESS,
    payload: response
  })
}

export function* fetchIfNeeded (action) {
  const allAliadas = yield select(fromEntities.getAliadas)
  const { aliadaId } = action.payload

  const aliadaExistsInState = aliadaId in allAliadas
  return aliadaExistsInState
    ? null
    : yield call(fetch, action)
}

// /////////////////////////////////////////////////////////////////////////////
// Watchers
// /////////////////////////////////////////////////////////////////////////////
export function* watchFetch () {
  yield fork(takeEvery, fromAliada.FETCH, fetch)
}

export function* watchFetchIfNeeded () {
  yield fork(takeEvery, fromAliada.FETCH_IF_NEEDED, fetchIfNeeded)
}

// /////////////////////////////////////////////////////////////////////////////
// Root Saga
// /////////////////////////////////////////////////////////////////////////////
export default function* rootSaga () {
  yield * [
    fork(watchFetch),
    fork(watchFetchIfNeeded)
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/aliada.js